import React from 'react';
import styles from './CancelRegistrationSection.module.scss';

interface Props {
    PageData?: any;
    Model?: any;
    handleClick:any;
}

const PrivacyPolicy= ({ PageData, Model, handleClick }: Props) => {

    const handleClose =() =>{
        handleClick(false) ;
    }

    return (

<div className="modal-overlay is-active">
    <div className="modal-dialog modal-md-dialog">
        <div className="modal-content">
            <a onClick={handleClose} className="modal-close" id="termsandcondition"></a>
            <div className="modal-body modal-scroll u-center">
                {PageData.PrivacyPolicy}
            </div>
        </div>
    </div>
</div>

    )
}

export default PrivacyPolicy